import { createClient } from '@supabase/supabase-js';

// Dedicated PKCE client for the password-reset flow ONLY.
//
// Why a separate client: the main app client (supabase.js) uses the implicit flow,
// where the reset link is NOT single-use (a clicked link keeps working until it
// expires - the reuse bug found 2026-06-30). The PKCE flow issues a single-use
// `?code=` (~5 min, exchanged exactly once via detectSessionInUrl), which fixes that.
//
// It has its OWN storageKey so it never collides with the main implicit client - both
// exist on index.html when the "Forgot password?" send runs. This client is used at
// BOTH ends of the flow:
//   1. the send  (model.sendPasswordResetEmail) - writes the PKCE code_verifier here,
//   2. the landing (Javascript/reset.js on reset.html) - reads it back to exchange the
//      ?code= and establish the recovery session.
// Both ends must run on the SAME origin (localStorage is origin-scoped), which is why
// redirectTo stays `${origin}/reset.html`.
export const resetClient = createClient(
  process.env.SUPABASE_URL,
  process.env.SUPABASE_ANON_KEY,
  {
    auth: {
      flowType: 'pkce',
      storageKey: 'pb-reset-auth',
      detectSessionInUrl: true,
      persistSession: true,
      autoRefreshToken: false,
    },
  }
);
